
<!-- Modal -->
<div class="modal fade" id="modalIdiomas" tabindex="-1" aria-labelledby="modalIdiomasLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalIdiomasLabel">Idiomas</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row" [formGroup]="form">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Idioma</label>
                            <div>
                                 <app-dropdown [options]="languages" formControlName="languageId"></app-dropdown>
                                  @if (form.get('languageId')?.invalid && (form.get('languageId')?.touched || form.get('languageLevelId')?.dirty)) {
                                    @if (form.get('languageId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label class="required-field">Nivel</label>
                            <div>
                                <app-dropdown [options]="languagLevels" formControlName="languageLevelId"></app-dropdown>
                                @if (form.get('languageLevelId')?.invalid && (form.get('languageLevelId')?.touched || form.get('languageLevelId')?.dirty)) {
                                    @if (form.get('languageLevelId')?.errors?.['required'] == true) {
                                        <div class="invalid-field">
                                            Este campo es requerido
                                        </div>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button (click)="closeModal()" type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    <button (click)="submit()" type="button" class="btn btn-primary">
                        @if(!isLoading()){
                            Guardar
                        }@else {
                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Guardando
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>